import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { log } from 'console';
import { OspService } from 'src/app/core/master-services/osp.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { checkInvAccess, warningMessage } from 'src/app/constants';
import * as moment from 'moment';
import { getUnique, getUniqueByKey, yearWeekToDate } from 'src/app/constants';
import { ContainerTapService } from 'src/app/services/container-tap/container-tap.service';
import * as mm from 'moment-timezone';


@Component({
  selector: 'app-tapped-qty-dialog',
  templateUrl: './tapped-qty-dialog.component.html',
  styleUrls: ['./tapped-qty-dialog.component.scss']
})
export class TappedQtyDialogComponent implements OnInit {
  tapedQtyEventEmitter = new EventEmitter();
  editTapedQtyEventEmitter = new EventEmitter();
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  userRole = localStorage.getItem('UserRoles');
  user = localStorage.getItem('workdayId');

  showDownloadUploadButtons: boolean = true;
  access;
  accessEdit = false;

  timezone = localStorage.getItem('timezone')

  rowData = [];
  errorMessage1: any;
  errorMessageUpdate = false;
  master_id: any;
  master_name: any;
  key_item: any;
  data_item: any;
  business_entity: any;
  new_key_item: any;
  cstatus: any;
  showaddpopup: boolean = false;
  showeditpopup: boolean = false;
  dock: any;
  popupname: any;
  shiftNumber: any;
  dayWeek: any;
  startTime: any;
  endTime: any;
  inMasterCalendar: any;
  inNextDay: any;
  dataItem: any;
  enableError: boolean = false;
  userForm: UntypedFormGroup;
  shiftNumbers: any[] = [];
  dayWeeks: any[] = [];
  masterCalendar: any[] = [];
  nextDay: any[] = [];
  errorMessage: any;
  hoursArray = new Array(24);
  mintuesArray = new Array(60);
  stockingDate: any;
  stockingTime: any;
  minDate: string;
  dateFormat = 'YYYY-MM-DD';
  newDate ;
  previousDate ;
  noSchedule: boolean = false

  addOrEditform: UntypedFormGroup = this.formBuilder.group({
    dock: [''],
    shiftNumber: [1],
    dayWeek: [2],
    inMasterCalendar: ['N'],
    inNextDay: ['N'],
    effectiveTo: [null],
    container: [''],
    kanban: [''],
    moduleNumber: [''],
    noOfLots: [''],
    stockingHoursHH: [''],
    stockingMintuesMM: [''],
    noOfPieces: [''],
    stockingDate: [''],
  },
  );
  warningMessage: string;
  itContact: any;
  successMessage: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogeRef: MatDialogRef<TappedQtyDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly ospService: OspService,
    private readonly spinner: NgxSpinnerService,
    private readonly containerTapService: ContainerTapService,
  ) { }
  get addOrEdit() {
    return this.addOrEditform.controls;
  }
  ngOnInit(): void {
    this.access = checkInvAccess();
    this.accessEdit = this.access?.functionalityAccess?.edit || false;
    this.noSchedule = false;
    this.newDate = String(mm().tz(this.timezone).format(this.dateFormat)).substring(0, 10);
    this.previousDate = String(mm().tz(this.timezone).subtract(1, 'day').format(this.dateFormat)).substring(0, 10);
  
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    this.onloadGrid()
    this.addOrEditform.controls.dock.setValue(this.data.dockList);
    this.addOrEditform.controls.container.setValue(this.data.container_renban);
    this.addOrEditform.controls.kanban.setValue(this.data.kanban);
    this.addOrEditform.controls.moduleNumber.setValue(this.data.module_number);
    this.addOrEditform.controls.noOfLots.setValue(this.data.lots);
    this.addOrEditform.controls.noOfPieces.setValue(this.data.pieces);
    this.business_entity = localStorage.getItem('namcvalue');
    today.setDate(today.getDate()); // Set to tomorrow
    this.minDate = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    if (this.data?.mode === 'update') {
      if (this.data.data?.dock) {
        this.addOrEdit.dock.setValue(
          this.data.data.dock
        );
      }
    }
  }
  onloadGrid() {
    this.removeMessage();
    const data = {
      business_entity: this.namcValue,
      dock: localStorage.getItem('dock'),
      container_renban: this.data.container_renban,
      module_number: this.data.module_number,
      workid: this.user,
      kanban: this.data.kanban,
      user_role: this.userRole,
    };

    // console.log(data, 'onloadData')
    this.spinner.show();
    this.containerTapService.scheduleTap(data).subscribe({
      error: this.errorCallback,
      next: (res) => {
        // console.log(res, 'res')
        this.spinner.hide();
        let scheduleData = res.body.data;

        if (scheduleData.length === 0) {
          this.noSchedule = true;
          localStorage.setItem('noSchedule', JSON.stringify(true));

          // // STEP 3: Set today's date in required format
          this.stockingDate = this.newDate

          this.addOrEditform.patchValue({
            // stockingHoursHH: finalHH,
            // stockingMintuesMM: finalMM,
            stockingDate: this.stockingDate,
          });

        }


        if (scheduleData.length > 0) {
          localStorage.setItem('noSchedule', JSON.stringify(false));
          this.rowData = scheduleData;
          this.stockingDate = this.rowData[0].stocking_date;
          this.stockingTime = this.rowData[0].stocking_time;
          this.stockingDate = this.convertToRequiredDateFormat(this.stockingDate);
          this.updateForm();
        } else {
          this.rowData = [];
          this.spinner.hide();
          // this.warningMessage = `${warningMessage.reportsNotUpdated}  ${this.itContact}.`;
        }
      },
    });
    return true;
  }
  convertToRequiredDateFormat(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Get month and pad with zero
    const day = date.getDate().toString().padStart(2, '0'); // Get day and pad with zero
    return `${year}-${month}-${day}`;
  }
  updateForm(): void {
    if (this.stockingTime && this.stockingDate) {
      // Assuming `stockingTime` is in "HH:mm" format
      const [hh, mm] = this.stockingTime.split(':').map(Number);

      // Update the form with the data
      this.addOrEditform.patchValue({
        stockingHoursHH: hh,
        stockingMintuesMM: mm,
        stockingDate: this.stockingDate,
      });
    }
  }
  formatNumber(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
  submitted: boolean = false;

  addDetails() {
    if (!this.addOrEditform.valid) {
      this.submitted = true;
      return;
    }

  }



  editRowShiftsDetails() {
    const stockingTimeNew = this.stockingTime;
    // console.log(stockingTimeNew, 'stockingTimeNew');

    if (this.addOrEditform.invalid) {
      this.submitted = true;
      return;
    }

    let stockingHoursHH: number | undefined = this.addOrEditform.get('stockingHoursHH')?.value;
    let stockingMintuesMM: number | undefined = this.addOrEditform.get('stockingMintuesMM')?.value;
    let stockingDate: string | undefined = this.addOrEditform.get('stockingDate')?.value;

    // Validate stockingDate
    if (!stockingDate || stockingDate.trim() === '') {
      this.warningMessage = 'Invalid Stocking date.';
      return;
    }

    // Validate time is not "00:00"
    if (stockingHoursHH === 0 && stockingMintuesMM === 0) {
      this.warningMessage = 'Invalid Stocking time.';
      return;
    }

    // Parse and validate stocking date and time with Michigan timezone
    const stockingDateTimeString = `${stockingDate}T${stockingHoursHH?.toString().padStart(2, '0')}:${stockingMintuesMM?.toString().padStart(2, '0')}:00`;
    const stockingDateTime = moment.tz(stockingDateTimeString, this.timezone).toDate();
    const currentDateTime = moment.tz(this.timezone).toDate(); // Get the current Michigan time

    // Check if stocking date and time is in the past
    if (stockingDateTime < currentDateTime) {
      this.warningMessage = 'Stocking date and time cannot be in the past.';
      return;
    }

    const formattedStockingTime = `${stockingHoursHH?.toString().padStart(2, '0')}:${stockingMintuesMM?.toString().padStart(2, '0')}:00`;

    const editEmittedData = {
      dock: this.addOrEdit.dock.value,
      container: this.addOrEdit.container.value,
      kanban: this.addOrEdit.kanban.value,
      moduleNumber: this.addOrEdit.moduleNumber.value,
      noOfPieces: this.addOrEdit.noOfPieces.value,
      noOfLots: this.addOrEdit.noOfLots.value,
      stockingHoursHH: stockingHoursHH,
      stockingMintuesMM: stockingMintuesMM,
      stockingDate: stockingDate,
      stockingTime: formattedStockingTime,
      scheduleData: JSON.parse(localStorage.getItem('noSchedule') ?? '{}'),
    };

    this.editTapedQtyEventEmitter.emit(editEmittedData);
    this.dialogeRef.close();
  }




  // Tap NOW
  editRowShiftsDetails2() {
    const stockingTimeNew = this.stockingTime;
    // console.log(stockingTimeNew, 'stockingTimeNew');

    if (this.addOrEditform.invalid) {
      this.submitted = true;
      return;
    }

    let stockingHoursHH: number | undefined = this.addOrEditform.get('stockingHoursHH')?.value;
    let stockingMintuesMM: number | undefined = this.addOrEditform.get('stockingMintuesMM')?.value;
    let stockingDate: any | undefined = this.addOrEditform.get('stockingDate')?.value;


    const formattedStockingTime = `${stockingHoursHH.toString().padStart(2, '0')}:${stockingMintuesMM.toString().padStart(2, '0')}:00`;

    const editEmittedData = {
      dock: this.addOrEdit.dock.value,
      container: this.addOrEdit.container.value,
      kanban: this.addOrEdit.kanban.value,
      moduleNumber: this.addOrEdit.moduleNumber.value,
      noOfPieces: this.addOrEdit.noOfPieces.value,
      noOfLots: this.addOrEdit.noOfLots.value,
      stockingHoursHH: stockingHoursHH,
      stockingMintuesMM: stockingMintuesMM,
      stockingDate: '',
      stockingTime: formattedStockingTime,
      scheduleData: JSON.parse(localStorage.getItem('noSchedule'))
    };

    this.editTapedQtyEventEmitter.emit(editEmittedData);
    this.dialogeRef.close();
  }

  onTimeChange(newTime: string): void {
    // console.log("New time selected:", newTime);  // Log or process the new time
    this.startTime = newTime;  // Update the component model with the new time
  }
  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  };

  errorCallback = (error) => {
    console.error(error);
    this.hideSpinner();

    this.removeMessage();
    this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
  };
  hideSpinner() {
    this.spinner.hide();
  }
  callRespectiveFunction() {
    if (this.data?.mode === 'update') {
      this.editRowShiftsDetails();
    } else {
      // console.log("add function is called");
      this.addDetails();
    }
  }
  callRespectiveFunction2() {
    if (this.data?.mode === 'update') {
      this.editRowShiftsDetails2();
    } else {
      // console.log("add function is called");
      this.addDetails();
    }
  }

  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);
    // Allow number keys, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}

